import { render } from "./stake-flake.vue?vue&type=template&id=77f3a641&scoped=true&ts=true"
import script from "./stake-flake.vue?vue&type=script&lang=ts"
export * from "./stake-flake.vue?vue&type=script&lang=ts"

import "./stake-flake.vue?vue&type=style&index=0&id=77f3a641&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77f3a641"]])

export default __exports__